import { render, staticRenderFns } from "./IssueSubscription.vue?vue&type=template&id=333036d3&"
import script from "./IssueSubscription.vue?vue&type=script&lang=js&"
export * from "./IssueSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports